<template>
  <div>
    <div class="w3-center w3-white outline w3-margin" style="padding:16px 8px 8px;">
      <i class="fa fa-check-circle w3-text-green" style="font-size:32pt;"></i>
      <h2 class="w3-margin-top">Thank you for your order!</h2>
      <p style="margin-top:0;">We'll send a confirmation email with details soon.</p>
    </div>
    <div class="orderPage w3-container" v-if="state.order">
      <div class="checkoutSuccessGrid">
        <div>
          <div class="w3-margin-bottom w3-padding w3-white outline">
            <h5>Payment Method</h5>
            <div class="outline cardbg w3-margin-top" v-for="(item, key, i) in state.user.stripeData.sources.data" :key="i">
              <template v-if="item.id && item.id === state.user.stripeData.default_source">
                <header class="w3-row outline">
                  <img src="../assets/cards/visa.png" v-if="item.brand === 'Visa'" />
                  <img src="../assets/cards/mastercard.png" v-if="item.brand === 'MasterCard'" />
                  <img src="../assets/cards/amex.png" v-if="item.brand === 'American Express'" />
                  <img src="../assets/cards/discover.png" v-if="item.brand === 'Discover'" />
                  <img src="../assets/cards/unknown.png" v-if="item.brand === 'Unknown'" />
                  <div class="w3-right" style="font-size:12px;">
                    <button class="w3-button rightButton" v-if="item.id === state.user.stripeData.default_source">DEFAULT</button>
                  </div>
                </header>
                <div class="w3-row w3-margin-bottom w3-center" style="font-family:'Open Sans'">
                  <div style="margin:25px auto 15px;">
                    <span style="font-size:20px; font-weight:300;">xxxx xxxx xxxx </span><span style="font-size:20px; font-weight:500;">{{item.last4}}</span>
                  </div>
                  <div class="w3-padding w3-left">
                    <span style="font-size:7px; float:left; margin-top:2px;">ZIP<br/>CODE</span>
                    <span style="padding-left:10px;">{{item.address_zip}}</span>
                  </div>
                  <div class="w3-padding w3-right">
                    <span style="font-size:7px; float:left; margin-top:2px;">VALID<br/>THRU</span>
                    <span style="padding-left:10px;">{{item.exp_month}} / {{item.exp_year}}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div>
          <div class="outline w3-white">
            <table class="w3-table" :class="state.width > 1024 ? '' : 'w3-responsive'">
              <tr class="w3-light-grey outline">
                <td>Item</td>
                <td class="w3-center" style="min-width:100px;">Period</td>
                <td class="w3-right-align" style="min-width:120px;">Amount</td>
              </tr>
              <tr v-for="(item, index) in state.savedCart.items" :key="index" class="w3-border-bottom">
                <td>{{item.description}}</td>
                <td class="w3-center">{{item.duration}} {{item.period}}(s)</td>
                <td class="w3-right-align">{{item.amount / 100 | currency}}</td>
              </tr>
            </table>
            <div class="w3-padding-v">
              <div class="w3-right-align w3-margin-right">
                Subtotal: {{state.savedCart.total / 100 | currency}}<br/>
                <b>Total: {{state.savedCart.total / 100 | currency}}</b>
              </div>
            </div>
            <div class="w3-margin-bottom w3-padding w3-white">
              <div class="w3-padding-v">
                <div class="w3-right-align">
                  <button class="w3-button w3-green w3-round w3-mobile" @click="returnToDashboard()">Return to Dashboard</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require("../dataStore").default;

export default {
  name: 'checkoutSuccess',
  data () {
    return {
      state: dataStore.state
    }
  },
  created() {
    if (!this.state.order) {
      // this.$router.replace('/')
    }
  },
  methods: {
    returnToDashboard() {
      this.state.savedCart = {items: [], total: 0}
      this.$router.replace('/')
      // TODO: email client order confirmation
    }
  }
}
</script>

<style scoped>
header {padding:6.5px 12px;}
header img {height:30px; margin:0;}
.rightButton {padding:6px 10px;}
.invoiceRow {cursor:pointer;}
.cardbg {background: #fff; margin-bottom: 8px;}
.cardbg:last-child {margin-bottom: 0;}
.checkoutSuccessGrid {display:grid; grid-template-columns: 1fr 1fr; grid-gap: 8px;}
</style>



// WEBPACK FOOTER //
// src/components/checkoutSuccess.vue